/*
 * (c) Copyright Reserved EVRYTHNG Limited 2021. All rights reserved.
 * Use of this material is subject to license.
 * Copying and unauthorised use of this material strictly prohibited.
 */

import { getCookie } from '../cookiesUtils.js';

/**
 * @returns {boolean}
 */
export function getAreCookiesAllowed() {
  const consent = getCookie('OptanonConsent');

  // OneTrust code for functional cookies group 'C0003'
  // Consent not given: ':0', consent given ':1'
  const FUNCTIONAL_COOKIES_CONSENT = 'C0003:1';
  return !!consent?.includes(FUNCTIONAL_COOKIES_CONSENT);
}

export function getIsCookieBannerClosed() {
  return !!getCookie('OptanonAlertBoxClosed');
}

/**
 * @returns {boolean}
 */
export function getIsLoaded() {
  return !!window?.OneTrust;
}

/**
 * @param {consentChangedCallback} onConsentChanged
 */
export function setConsentChangedHandler(onConsentChanged) {
  window.addEventListener('OneTrustGroupsUpdated', () =>
    onConsentChanged(getAreCookiesAllowed(), getIsCookieBannerClosed()),
  );
}
